import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    collapsibleSectionHeader: {
      paddingLeft: '0px',
      paddingRight: '0px',
      marginTop: '34px',
      marginBottom: '0px',
      '& div.MuiAccordionSummary-root': {
        padding: '0px'
      },
      '& div.MuiAccordionDetails-root': {
        padding: '0px'
      }
    },
    sectionTitle: {
      fontWeight: 'bold',
      opacity: 0.7
    },
    sectionDivider: {
      backgroundColor: theme && theme.palette.primary.main
    }
  })
